"use client";

import React from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Badge } from "@/components/ui/badge";
import { Check } from "lucide-react";
const testimonials = [{
  author: "Sarah Jenkins",
  quote: "Webshingle turned my vague ideas into a stunning portfolio in minutes. The AI prompt feature is pure magic.",
  position: "Creative Director"
}, {
  author: "Marcus Thorne",
  quote: "Finally, a WordPress service that doesn't require a degree in computer science. Simple, fast, and beautiful.",
  position: "Small Business Owner"
}, {
  author: "Elena Rodriguez",
  quote: "The high-converting design and managed hosting have doubled my site's performance. Best investment this year.",
  position: "E-commerce Founder"
}];
export default function VoicesOfTheEvening() {
  return <section data-section-id="221547" id="success-stories" className="bg-background text-foreground">
      <div className="bg-background py-24 md:py-32 px-4 md:px-8">
        <div className="max-w-5xl mx-auto">
          <Carousel opts={{
          align: "center",
          loop: true
        }} className="w-full relative">
            <CarouselContent>
              {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i}>
                  <div className="flex flex-col items-center justify-center text-center px-8 md:px-24">
                    <blockquote className="text-2xl md:text-[24px] leading-tight md:leading-snug font-default font-semibold mb-10 text-secondary">
                      "{testimonial.quote}"
                    </blockquote>
                    
                    <div className="flex flex-col items-center gap-3">
                      <span className="font-default font-bold tracking-wide uppercase text-sm text-secondary">
                        {testimonial.author}
                      </span>
                      
                      <Badge variant="outline" className="border-primary/30 text-muted-foreground bg-transparent rounded-md px-3 py-1 gap-1.5">
                        <Check className="size-3 text-primary" />
                        <span className="uppercase tracking-wider text-[10px] font-medium">
                          {testimonial.position}
                        </span>
                      </Badge>
                    </div>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
            
            <div className="hidden md:block">
              <CarouselPrevious variant="ghost" className="text-muted-foreground hover:text-primary hover:bg-transparent [&_svg]:size-8 size-12 -left-4 border-none" />
              <CarouselNext variant="ghost" className="text-muted-foreground hover:text-primary hover:bg-transparent [&_svg]:size-8 size-12 -right-4 border-none" />
            </div>
            
            <div className="flex justify-center gap-4 mt-12 md:hidden">
              <CarouselPrevious variant="outline" className="static translate-y-0 border-border text-secondary hover:bg-accent hover:text-primary rounded-md" />
              <CarouselNext variant="outline" className="static translate-y-0 border-border text-secondary hover:bg-accent hover:text-primary rounded-md" />
            </div>
          </Carousel>
        </div>
      </div>
    </section>;
}